
import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

// Create a subset of ButtonProps but with our custom variant options
interface HossButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "outline" | "subtle" | "link";
  size?: "default" | "sm" | "lg" | "icon";
}

export const HossButton: React.FC<HossButtonProps> = ({
  variant = "default",
  size = "default",
  className = "",
  children,
  ...props
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case "default":
        return "bg-[#081426] hover:bg-[#0a2740] text-white shadow-md hover:shadow-lg transition-all";
      case "outline":
        return "bg-transparent border border-[#417F96] text-[#417F96] hover:bg-[#417F96]/5 transition-all";
      case "subtle":
        return "bg-[#e8f1f9] hover:bg-[#dcecfb] text-[#1d4ed8] hover:shadow-sm transition-all";
      case "link":
        return "bg-transparent text-[#417F96] hover:underline transition-all";
      default:
        return "bg-[#081426] hover:bg-[#0a2740] text-white shadow-md hover:shadow-lg transition-all";
    }
  };

  const getSizeStyles = () => {
    switch (size) {
      case "sm":
        return "text-sm px-4 py-1.5 rounded-full";
      case "lg":
        return "text-lg px-8 py-3 rounded-full";
      case "icon":
        return "p-2 rounded-full";
      default:
        return "px-6 py-2 rounded-full";
    }
  };

  return (
    <button
      className={cn(`inline-flex items-center justify-center ${getVariantStyles()} ${getSizeStyles()} font-medium`, className)}
      {...props}
    >
      {children}
    </button>
  );
};
